import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import classnames from 'classnames';

import { getDocumentToReactComponentsOptions } from 'helpers/LandingPageHelpers';

import type { IContentfulRichText, Nullable } from 'types';

import styles from './AlphaTemplateTextBlock.module.scss';

interface Props {
  title: Nullable<IContentfulRichText>,
  description: Nullable<IContentfulRichText>,
  titleAlign: 'left' | 'center',
  descriptionAlign: 'left' | 'center',
  type: 'default' | 'regulation' | 'disclaimer',
  isMobilePreview: boolean
}

const AlphaTemplateTextBlock = (props: Props) => {

  const {
    title, description,
    titleAlign, descriptionAlign,
    type,
    isMobilePreview
  } = props;

  const { json: titleJson } = title || {};
  const { json: descriptionJson } = description || {};

  const options = React.useMemo(() => getDocumentToReactComponentsOptions({ isMobilePreview }), [isMobilePreview]);

  return (
    <div className={classnames(styles.root, styles[type])}>
      <div className={styles.inner}>
        {title && <div className={classnames(styles.title, styles[titleAlign])}>{documentToReactComponents(titleJson, options)}</div>}
        {description && <div className={classnames(styles.description, styles[descriptionAlign])}>{documentToReactComponents(descriptionJson, options)}</div>}
      </div>
    </div>
  );
};

export default AlphaTemplateTextBlock;
